import { render, staticRenderFns } from "./job-report-main.component.vue?vue&type=template&id=71fff936&scoped=true"
import script from "./job-report-main.component.ts?vue&type=script&lang=ts&external"
export * from "./job-report-main.component.ts?vue&type=script&lang=ts&external"
import style0 from "./job-report-main.component.vue?vue&type=style&index=0&id=71fff936&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fff936",
  null
  
)

export default component.exports